<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <ConnectionPicker v-model="value.parameter1" title="Data Connection" />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="value.parameter2"
          hide-details
          filled
          label="Command Text"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <CustomColumnValueListEditor
          title="Parameter Values"
          v-model="value.values"
        />

        <ServerCustomValueListEditor
          title="Parameter Values"
          v-model="value.values"
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="value.parameter3"
          hide-details
          label="Is Query"
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <DataOutputPicker
          title="Output (Id)"
          v-model="value.parameter4"
          :workflow="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConnectionPicker from "../../ui/shared/ConnectionPicker.vue";
import ServerCustomValueListEditor from "../../ui/shared/ServerCustomValueListEditor.vue";
import DataOutputPicker from "../../ui/shared/DataOutputPicker.vue";

export default {
  name: "ExecuteComandDesigner",

  components: {
    ConnectionPicker,
    ServerCustomValueListEditor,
    DataOutputPicker,
  },

  props: ["value"],
};
</script>